import { getTNC } from '@ttstr/api';
import { ThunkActionCreator } from '.';

export const TNC_REQUESTED        = 'CATALOG.TNC_REQUESTED';
export const TNC_RECEIVED         = 'CATALOG.TNC_RECEIVED';
export const TNC_FAILED           = 'CATALOG.TNC_FAILED';
export const TNC_RECEIVE_DONE     = 'CATALOG.TNC_RECEIVE_DONE'

export const receiveTnc: ThunkActionCreator = (tncId: number) => async (dispatch) => {
  dispatch({
    type: TNC_REQUESTED,
    payload: {
      tncId,
    },
  });

  try {
    const tnc = await getTNC(tncId);

    dispatch({
      type: TNC_RECEIVED,
      payload: {
        tnc,
      },
    });
    return tnc;
  } catch (e) {
    dispatch({
      type: TNC_FAILED,
      payload: {
        e,
      },
    });
    throw e;
  } finally {
    dispatch({
      type: TNC_RECEIVE_DONE,
      payload: {
        tncId,
      },
    });
  }
};


